import React from 'react'
import { connect } from 'react-redux'
import getData from '../../functions/getData'
import { SOCIALMEDIA } from '../../constants/state'
import toJS from '../../containers/general/toJS'
import Translation from '../Translation/cont/Translation'

const mapStateToProps = (state) => ({
    socialmedia: getData(state, SOCIALMEDIA),
})

const getClassName = type => {
    if('facebook' === type) {
        return ' link-social-fb'
    } else if('twitter' === type) {
        return ' link-social-twitter'
    } else if('tiktok' === type) {
        return ' link-social-tiktok'
    } else if('whatsapp' === type) {
        return ' link-social-whatsapp'
    } else {
        return ' link-social-insta'
    }
}

const getLinkData = socialmedia => {
    const linkData = []

    if(!socialmedia) {
        return linkData
    }

    Object.keys(socialmedia).map(type => {
        if(socialmedia[type]) {
            linkData.push({
                className: getClassName(type),
                url: socialmedia[type],
                text: type
            })
        }
    })

    return linkData
}



const SocialMedia = ({
    socialmedia,
    className='',
    classNameTitle='',
    classNameListWrapper='',
    classNameList=''
}) => {
    const linkData = getLinkData(socialmedia)

    if(0 === linkData.length)  {
        return ''
    } else {
        return (
            <div className={'socialmedia' + (className ? ' ' + className : '')}>
                <h3 className={"socialmedia-head" + (classNameTitle ? ' ' + classNameTitle : '')}>
                    <Translation id="print_newsletter_structure_social_media"/>
                </h3>

                <div className={"socialmedia-list-wrapper" + (classNameListWrapper ? ' ' + classNameListWrapper : '')}>
                    <div className={"socialmedia-list" + (classNameList ? ' ' + classNameList : '')}>
                        {linkData.map(({className, url, text}) => (
                            <div 
                                key={className}
                                className={"link-social" +  className}
                            >
                                <a href={url} rel="noreferrer" target="_blank">
                                    <span className="screen-reader-text">{text}</span>
                                </a>
                            </div>
                        ))}
                     </div>
                </div>
            </div>
        )
    }
}


export default connect(mapStateToProps, null)(toJS(SocialMedia))